import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Project } from "@interfaces/project.interface";
import { PurchaseLog } from "@interfaces/models/purchaseLog.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { ExportLogService } from "@services/exportLog.service";
import { SupplierService } from "@services/supplier.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { ProjectService } from "@services/project.service";
import { ToastService } from "angular-toastify";
import { ProtectedGridService } from "@services/protectedGrid.service";

@Component({
	moduleId: module.id,
	selector: "purchaseLogs",
	styleUrls: ["purchaseLogs.css"],
	templateUrl: "purchaseLogs.html"
})
export class PurchaseLogsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Purchase Log"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: PurchaseLog[] = [];
	projects: Project[]= [];
	purchaseTypes: any[] =[];
	statuses: any;
	suppliers: Supplier[] = [];
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: PurchaseLogService, private projectService: ProjectService, private protectedGridService: ProtectedGridService, private supplierService: SupplierService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-shapes", method: "goToItems", text: "Items" },{ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.headerSecondaryButtons.push();
		this.title = `${this.itemType}s`;
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getSuppliers();
		this.getProjects();
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Purchase Logs")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getProjects() {
		this.projectService.getAll()
			.subscribe(
				(res: any) => this.projects = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => this.suppliers = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	goToItems() {
		this.router.navigate(["admin/purchasableItems"]);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Purchase Logs";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}